import MatchedMap from 'utilities/src/matchedMap';
import { HeaderBGEnum } from '../../types/_bg';

const headerColorClasses = new MatchedMap([
  [HeaderBGEnum.Light, 'bg-site-neutrals-0 text-site-neutrals-900'],
  [HeaderBGEnum.Dark, 'bg-site-neutrals-900 text-site-neutrals-0'],
]);

export default headerColorClasses;
